"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.isString = isString;
/* eslint-disable func-names */
function isString(value) {
  return typeof value == 'string' && value.trim().length > 0; // eslint-disable-line
}
var _default = exports.default = isString;